


























































































































































































































































































































































































































import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  ALL_OFFICES_BY_CUSTOMER,
  ALL_OFFICES_ERRORS,
  CUSTOMER_DETAILS,
  GET_ALL_OFFICES_BY_CUSTOMER,
  GET_OFFICE_DETAILS,
  OFFICE_DETAILS,
  SET_UPDATE_OFFICE_SETTINGS_MODAL,
  UPDATE_OFFICE,
  UPDATE_OFFICE_SETTINGS_MODAL,
  UPDATE_OFFICE_SETTINGS_MODAL_ERRORS,
} from '@/types/customer.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { Grid } from '@/models/Grid.model';
import { GridColumn } from '@/models/GridColumn.model';
import Mock from '@/globals/backoffice.mock';
import { Utils } from '@/globals/Utils';

@Component({})
export default class OfficesSettingsComponent extends Vue {
  @Inject() public $validator: any;

  @Action(GET_ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public getAllOfficesByCustomer;
  @Action(GET_OFFICE_DETAILS, StoreNamespace.CUSTOMER) public getOfficeDetails;
  @Action(UPDATE_OFFICE, StoreNamespace.CUSTOMER) public updateOffice;

  @Mutation(SET_UPDATE_OFFICE_SETTINGS_MODAL, StoreNamespace.CUSTOMER) public setUpdateOfficeSettingsModal;

  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;
  @Getter(OFFICE_DETAILS, StoreNamespace.CUSTOMER) public officeDetails!: CustomerDetailsModel;
  @Getter(UPDATE_OFFICE_SETTINGS_MODAL, StoreNamespace.CUSTOMER) public updateOfficeSettingsModal!: boolean;
  @Getter(UPDATE_OFFICE_SETTINGS_MODAL_ERRORS, StoreNamespace.CUSTOMER)
  public updateOfficeSettingsModalErrors!: string[];
  @Getter(ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public allOfficesByCustomer!: Grid;
  @Getter(ALL_OFFICES_ERRORS, StoreNamespace.CUSTOMER) public allOfficesErrors!: string[];

  public columns: GridColumn[] = [];
  public officeDetailsToUpdate: CustomerDetailsModel = {} as CustomerDetailsModel;
  public officesMock: any = {};
  public ipRanges: any[] | undefined = [];

  public destroyed() {
    this.setUpdateOfficeSettingsModal(false);
  }

  public onInput(event: any, prop: string): void {
    if (prop) {
      this.officeDetailsToUpdate = { ...this.officeDetailsToUpdate, [prop]: event };
    }
  }

  private mounted() {
    this.officesMock = Mock.customer;
    this.setUpdateOfficeSettingsModal(false);
    this.getAllOfficesByCustomer(this.customerDetails.indexNum);
    this.initColumns();
    const ipRangesList = this.officeDetails.ipToCheck?.split(',');
    this.ipRanges = ipRangesList?.map(i => i?.split('-'));
    this.ipRanges = this.ipRanges || [];
  }

  private initColumns() {
    this.columns.push({
      property: 'indexNum',
      header: 'back_office.settings.offices.indexNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeNum',
      header: 'back_office.settings.offices.officeNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeName',
      header: 'back_office.settings.offices.officeName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeStatusDesc',
      header: 'back_office.settings.offices.activeFlag',
      hideSorting: true,
    } as GridColumn);
  }

  private onRowClicked(item: CustomerDetailsModel) {
    this.getOfficeDetails({
      requestBody: {
        indexNum: item.indexNum,
        officeNum: item.officeNum,
      },
    });
  }

  private updateOfficeSettings() {
    this.$validator.validateAll('payrollOfficeSettings').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        if (!this.officeDetailsToUpdate.empDataUpdateType) {
          this.officeDetailsToUpdate.empDataUpdateType = 0;
        }
        if (!this.officeDetailsToUpdate.activeFlag) {
          this.officeDetailsToUpdate.activeFlag = false;
        }
        if (!this.officeDetailsToUpdate.treeType) {
          this.officeDetailsToUpdate.treeType = 0;
        }
        const fixedRanges = Utils.checkIpsNotEmpty(this.ipRanges);
        if (fixedRanges.length) {
          this.officeDetailsToUpdate.ipToCheck = fixedRanges?.map(i => i.join('-')).join(',');
        } else {
          this.officeDetailsToUpdate.ipToCheck = '';
          this.ipRanges = [];
        }
        this.updateOffice(this.officeDetailsToUpdate);
      }
    });
  }

  private closeModal() {
    this.setUpdateOfficeSettingsModal(false);
  }

  private onRequiredDocs(item: any) {
    if (item !== undefined) {
      this.officeDetailsToUpdate.requiredDocs = item;
    }
  }

  private onPensionerOfficeType(item: any) {
    if (item !== undefined) {
      this.officeDetailsToUpdate.pensionerOfficeType = item;
    }
  }

  public onCellPhoneEventSrc(event: Record<string, string>): void {
    if (event) {
      this.officeDetailsToUpdate.cellPhoneEventSrc = event.code;
      this.officeDetailsToUpdate.cellPhoneFieldNameSrc = event.event
    }
  }

  public onEmailEventSrc(event: Record<string, string>): void {
    if (event) {
      this.officeDetailsToUpdate.emailEventSrc = event.code;
      this.officeDetailsToUpdate.emailFieldNameSrc = event.event
    }
  }

  private addIpRange() {
    this.ipRanges?.push([]);
  }

  private updateIpRange(value: string[], index: any) {
    if (this.ipRanges) {
      this.ipRanges[index] = value;
    }
  }

  private deleteIpRange(index: number) {
    this.ipRanges?.splice(index, 1);
  }

  get emailEventSrc(){
    if(!this.officeDetailsToUpdate?.emailEventSrc || !this.officeDetailsToUpdate?.emailFieldNameSrc){
      return null
    }

    return {
      code: this.officeDetailsToUpdate?.emailEventSrc,
      event: this.officeDetailsToUpdate?.emailFieldNameSrc,
      description: `${this.officeDetailsToUpdate?.emailEventSrc} - ${this.officeDetailsToUpdate?.emailFieldNameSrc}`
    }
  }

  get phoneEventSrc(){
    if(!this.officeDetailsToUpdate?.cellPhoneEventSrc || !this.officeDetailsToUpdate?.cellPhoneFieldNameSrc){
      return null
    }

    return {
      code: this.officeDetailsToUpdate?.cellPhoneEventSrc,
      event: this.officeDetailsToUpdate?.cellPhoneFieldNameSrc,
      description: `${this.officeDetailsToUpdate?.cellPhoneEventSrc} - ${this.officeDetailsToUpdate?.cellPhoneFieldNameSrc}`
    }
  }

  @Watch('officeDetails')
  private onOfficeDetailsChanged() {
    this.officeDetailsToUpdate = this.officeDetails;
    const ipRangesList = this.officeDetails.ipToCheck?.split(',');
    this.ipRanges = ipRangesList?.map(i => i?.split('-'));
    this.ipRanges = this.ipRanges || [];
  }

}

